<div class="modal">
  <div class="card card--xl">
    <div class="card-header">
      <div class="card-title">Lista materijala</div>
    </div>
    <div class="card-body card-body-scrollable">
      <ng-container *ngFor="let material of order.materials; let i = index; trackBy: trackByFn">
        <div class="row">
          <div class="col-12" *ngIf="i > 0">
            <hr>
          </div>
          <div class="col-1">
            <div class="fw-bold">{{ material?.ord }}</div>
          </div>
          <div class="col-3">
            <label class="form-label">Materijal
              <div class="d-inline-flex ms-2">
                <div class="blinker blinker--red"
                     *ngIf="material.quantityIssued > 0 && !material.isReturned"></div>
                <div class="blinker blinker--blue"
                     *ngIf="material.quantityIssued === 0 && material.requestedByUserId"></div>
              </div>
            </label>
            <div>{{ material.materialName }}</div>
            <div class="fw-bold">{{ material.nonStandardMaterialId || material.materialId }}</div>
            <app-tag [isActive]="true" [sector]="material.materialSector"></app-tag>
          </div>
          <div class="col-2">
            <label class="form-label">Trebovanje</label>
            <div>
              Planirano: {{ material.materialQuantity | digitFormat }} {{ material.materialUnit }}
            </div>
            <div>Izdato: {{ material.quantityIssued | digitFormat }} {{ material.materialUnit }}</div>
            <div>
              Potrošeno: {{ showSpentQuantityMaterial(material) | digitFormat }} {{ material.materialUnit }}
            </div>
            <div>
              Vraćeno: {{ material.quantityReturned | digitFormat }} {{ material.materialUnit }}
            </div>
          </div>
          <div class="col-3">
            <label class="form-label">Status</label>
            <div>Status: {{ sharedService.translateStatus(material.status) }}</div>
            <div class="mb-1">Rezervisano:
              <div class="tag tag-{{material.isReserved ? 'green' : 'red'}}">{{ material.isReserved ? 'Da' : 'Ne' }}
              </div>
            </div>
            <div>Razduženo:
              <div class="tag tag-{{material.isReturned ? 'green' : 'red'}}">{{ material.isReturned ? 'Da' : 'Ne' }}
              </div>
            </div>
          </div>

          <div class="col-3">
            <button type="button"
                    ngxClickStopPropagation
                    *ngIf="permissionHelper.isEnabledMethod('issueMaterial')"
                    class="btn btn-secondary btn-sm me-3"
                    (click)="onOpenIssueMaterialModal(material)">Izdato/Vraćeno
            </button>
            <button type="button"
                    ngxClickStopPropagation
                    *ngIf="permissionHelper.isEnabledMethod('returnMaterial')"
                    class="btn btn-secondary btn-sm"
                    (click)="onReturnMaterial(material.workOrderMaterialId)">Razduži
            </button>
            <button type="button"
                    ngxClickStopPropagation
                    class="btn btn-secondary btn-sm mt-3"
                    *ngIf="permissionHelper.isEnabledMethod('issuedMaterialCorrection')"
                    (click)="onOpenCorrectionOfMaterialIssuanceModal(material)">Korekcija - Izdato/Vraćeno
            </button>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-1"></div>
          <div class="col-3">
            <ng-container *ngIf="material.plannedByUserName">
              <label class="form-label">Planirao</label>
              <div class="d-flex align-items-center mb-2">
                <div class="avatar d-block me-2"
                     [style.backgroundImage]="'url('+ material.plannedByUserPhoto +')'">
                </div>
                <div>{{ material.plannedByUserName }}</div>
              </div>
            </ng-container>

            <ng-container *ngIf="material.requestedByUserName">
              <label class="form-label">Trebovao</label>
              <div class="d-flex align-items-center mb-2">
                <div class="avatar d-block me-2"
                     [style.backgroundImage]="'url('+ material.requestedByUserPhoto +')'">
                </div>
                <div>{{ material.requestedByUserName }}</div>
              </div>
            </ng-container>

            <ng-container *ngIf="material.issuedByUserName">
              <label class="form-label">Izdao</label>
              <div class="d-flex align-items-center">
                <div class="avatar d-block me-2"
                     [style.backgroundImage]="'url('+ material.issuedByUserPhoto +')'">
                </div>
                <div>{{ material.issuedByUserName }}</div>
              </div>
            </ng-container>
          </div>

          <div class="col-2">
            <label class="form-label">Komentar</label>
            <div>{{ material.comment || '/' }}</div>
          </div>

          <div class="col-3">
            <label class="form-label">Komentar nabavke</label>
            <div>{{ material.procurementComment || '/' }}</div>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="card-footer text-end">
      <button class="btn btn-secondary btn-question" (click)="emitFalse()">Nazad</button>
    </div>
  </div>
</div>
